import styled from 'styled-components';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Select/SelectGroup');
export var SelectGroup = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-w2a6z1-0"
})(["display:flex;"]);